import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn } from '@angular/router';

import { ExtendedRoute } from '@hdms/shared/common-types';

import { EnvironmentService } from '../environment/environment.service';
import { RouterHelperService } from '../router/router-helper.service';

export const canActivateMobileApp: CanActivateFn = route => canMatchMobileApp(route, null);

export const canMatchMobileApp: CanMatchFn = (route: ExtendedRoute) =>
  !inject(EnvironmentService).mobileApp || !route.data.disabledForMobileApp;

export const canActivateMobileAppReroute: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const routerHelper = inject(RouterHelperService);
  const environmentService = inject(EnvironmentService);

  const mobileAppReroute = route.data.mobileAppReroute;
  const mobileApp = environmentService.mobileApp;

  if (mobileApp && mobileAppReroute) {
    return routerHelper.createSilentRerouteUrlTree([mobileAppReroute]);
  }
  return true;
};
